<template>
    <form class="form-horizontal" v-if="id_rastreador">
        <div class="form-group">
            <label for="tipo_ip_url" class="col-sm-2 control-label">Comando:</label>
            <div class="col-sm-6">
                <input type="text" v-model="comando" class="form-control" id="comando" />
            </div>
        </div>

        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-4">
                <button @click="send()" type="button" class="btn btn-sm btn-success">
                    <i class="fa fa-save"></i> ENVIAR CONFIGURAÇÃO
                </button>
            </div>
            <div class="col-sm-4"></div>
            <div class="col-sm-2">
                <div class="dropup">
                    <button class="btn btn-sm btn-block btn-default dropdown-toggle" type="button" id="dropdownMenuComandoLivre" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                        <i class="fa fa-list-alt"></i> AÇÕES
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuComandoLivre">
                        <li>
                            <button @click="sendAll()" type="button" class="btn btn-xs btn-success">
                                <i class="fa fa-save"></i> ENVIAR PARA TODOS DO MESMO MODELO
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </form>
</template>
<script>
    import { Bus } from '../../../../class/bus';
    import { Comandos } from '../../../../class';

    export default {
        name: "ComandoLivre",
        props: {
            id_rastreador: {
                default: null
            }
        },
        data () {
            return {
                comando: null
            };
        },
        methods: {
            send () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Comandos.free(this.id_rastreador, this.comando);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            },
            sendAll () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar este comando para todos os veículos do mesmo modelo?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Comandos.freeAll(this.id_rastreador, this.comando);
                        Bus.$emit('comandos');
                        toastr.success("Comando enviado para todos do mesmo modelo!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Comando não enviado!");
                    }
                });
            }
        }
    };
</script>
